import Social, { Platform } from "../social";

const Header = () => {
  return (
    <header className="w-full h-32 flex flex-row justify-between items-center text-white flex-shrink-0">
      <section className="flex-[1] h-full flex items-center flex flex-row justify-center items-center">
        <div className="flex-1 flex justify-center items-center">
          <img src="/images/logo.png" className="w-20 mobile:w-32" alt="" />
        </div>
        <div className="flex-1 mobile:hidden"></div>
      </section>
      <section className="flex-[1] h-full flex items-center mobile:hidden">
        <div className="w-full flex justify-end gap-5 pr-16">
          {[Platform.EMAIL, Platform.INSTAGRAM].map((platform) => (
            <Social platform={platform} size={28} />
          ))}
        </div>
      </section>
    </header>
  );
};

export default Header;
